module.exports = "mat-card{\n  margin-bottom: 20px;\n  \n}\n\n.pos-bottom-right{\n  position: fixed;\n  display: block;\n  right: 0;\n  bottom: 0;\n  margin-right: 40px;\n  margin-bottom: 40px;\n  z-index: 900;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modulos/encuestas/encuestas.component.css
// module id = ./src/app/modulos/encuestas/encuestas.component.css
// module chunks = main